module.exports = __webpack_public_path__ + "static/media/raw-outside-air-temp.7c9c86ab.svg";